export const SET_INSURANCE_PROVIDER = 'SET_INSURANCE_PROVIDER';

export const setInsuranceProvider = ({ insuranceProvider }) => ({
  type: SET_INSURANCE_PROVIDER,
  payload: {
    insuranceProvider
  }
});
